import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { Box, Grid } from "@material-ui/core";
import Loading from "../../../components/isLoading";
import TableView from "../../../components/Table/TableView";
import { fetchUsersData } from "../../../redux/users/index";
import ListItemMenu from "../../../components/Menu/ListItemMenu";
import TextField from "../../../components/CustomInput/TextField";
import CustomSelect from "../../../components/CustomSelect/SimpleCustomSelect";
import CustomDialog from "../../../components/Dialogs/CustomDialog";
import apiService from "../../../services/apiService";
import Toast from "../../../components/MessageToast";
import ConfirmDialog from "../../../components/Dialogs/ConfirmationDialog";
import { NavLink } from "react-router-dom";

export default () => {
	const usersData = useSelector((state) => state.users);
	const dispatch = useDispatch();

	const [state, setState] = useState({
		model: false,
	});

	useEffect(() => {
		dispatch(fetchUsersData());
	}, []);

	const headCells = [
		{
			id: "firstName",
			numeric: false,
			label: "First Name",
		},
		{
			id: "lastName",
			numeric: false,
			label: "Last Name",
		},
		{
			id: "email",
			numeric: false,
			label: "Email",
		},
		{
			id: "phoneNumber",
			numeric: false,
			label: "Phone Number",
		},
		{
			id: "title",
			numeric: false,
			label: "Title",
		},
		{
			id: "role",
			numeric: false,
			label: "Role",
		},
		{
			id: "action",
			numeric: false,
			label: "",
		},
	];

	const rows =
		usersData.data.results?.map((el) => ({
			fistName: el.firstName,
			lastName: el.lastName,
			email: el.email,
			phoneNumber: el.phoneNumber,
			title: el.jobTitle || "Not set",
			role: el.role,
			action: (
				<ListItemMenu
					menu={[
						{
							primary: "Change role",
							onClick: () =>
								toggleModel({
									user: el,
									changeRole: true,
								}),
						},
						{
							primary: "Delete user",
							onClick: () =>
								toggleModel({
									user: el,
									removeUser: true,
								}),
						},
					]}
				/>
			),
			link: `/users/${el.id}`,
		})) || [];

	const changeUserRoleComponent = () => {
		return (
			<Box>
				<TextField
					label="Name"
					fullWidth
					value={state.user?.firstName + " " + state.user?.lastName}
					disabled
				/>
				<br></br>
				<TextField
					label="Email"
					fullWidth
					type="email"
					value={state.user?.email}
					disabled
				/>
				<br></br>
				<CustomSelect
					onInputChange={() => {}}
					onChange={handleUserRoleChange}
					options={[
						{ label: "Administrator", value: "admin" },
						{ label: "Content editor", value: "editor" },
					]}
					value={state.selectedRole || "Select Role"}
				/>
			</Box>
		);
	};

	const toggleModel = (action) => {
		if (action.changeRole)
			setState({
				...state,
				selectedRole: null,
				model: !state.model,
				user: action.user,
				changeRole: action.changeRole,
			});
		else if (action.removeUser) {
			setState({
				...state,
				user: action.user,
				confirmModel: true,
				confirmTitle: "Confirm removing user",
				confirmMessage: `Are sure you want to remove ${action.user.email} from BRAC`,
				danger: true,
				confirmText: "Remove",
				removeUser: action.removeUser,
			});
		} else
			setState({
				...state,
				selectedRole: null,
				user: null,
				model: false,
				confirmModel: false,
				removeUser: false,
				changeRole: false,
			});
	};

	const onConfirm = () => {
		if (state.changeRole) onChangeUserRole();
		else if (state.removeUser) onRemoveUser();
		else {
		}
	};

	const handleUserRoleChange = (selectedOption) => {
		setState({ ...state, selectedRole: selectedOption.value });
	};

	const onRemoveUser = async () => {
		setState((prev) => ({ ...prev, loading: true }));
		const response = await apiService({
			method: "DELETE",
			path: `/api/users/${state.user?.id}`,
		});
		Toast({
			message: response.message,
			type: response.error ? "error" : "success",
			duration: 5000,
			onClose: () => {
				setState((prev) => ({ ...prev, loading: false }));
				toggleModel({});
				if (!response.error) dispatch(fetchUsersData());
			},
		});
	};

	const onChangeUserRole = async () => {
		setState((prev) => ({ ...prev, loading: true }));
		const response = await apiService({
			method: "PATCH",
			path: `/api/users/${state.user.id}`,
			data: {
				role: state.selectedRole,
			},
		});
		Toast({
			message: response.message,
			type: response.error ? "error" : "success",
			duration: 5000,
			onClose: () => {
				setState((prev) => ({ ...prev, loading: false }));
				if (!response.error) dispatch(fetchUsersData());
			},
		});
	};

	return (
		<div>
			{usersData.loading && !usersData.data[0] ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							padding: "15px",
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<Button
							component={NavLink}
							to="/users/new"
							variant="outlined"
							sx={{
								color: "#E00186",
								border: "1px solid #E00186",
								fontFamily: "Arial",
								"&:hover": {
									color: "#fff",
									backgroundColor: "#E00186",
									border: "1px solid #E00186",
								},
							}}
						>
							Add new user
						</Button>
					</div>
					<div>
						<TableView
							dense
							headCells={headCells}
							rows={rows}
							title="BRAC users"
						/>
					</div>
				</>
			)}

			<CustomDialog
				title={state.changeRole ? "Change user role" : "Add BRAC user"}
				okText={state.changeRole ? "Apply" : "Add"}
				open={state.model}
				fullWidth
				content={state.changeRole ? changeUserRoleComponent() : null}
				onCancel={toggleModel}
				onConfirm={onConfirm}
				loading={state.loading}
			/>

			<ConfirmDialog
				open={state.confirmModel || false}
				title={state.confirmTitle}
				message={state.confirmMessage}
				confirmText={state.confirmText}
				danger={state.danger}
				onCancel={() => toggleModel({})}
				onConfirm={onConfirm}
				loading={state.loading}
			/>
		</div>
	);
};
